import { lazy } from 'react';
import paths from '../paths';
import { createRoute } from 'constants/utils';
const Customers = lazy(() => import('../../components/pages/customer/customers/Customers'));
const Customer = lazy(() => import('../../components/pages/customer/customerDetails/Customer'));

export const customerRoutes = (abilities) => {
  return [
    (abilities?.customer_service?.read ?? false) && createRoute(paths.customers, Customers),
    (abilities?.customer_service?.read ?? false) && createRoute(paths.customer(), Customer),
  ];
};
